// src/components/password-baul/actions/update-password.action.ts
import { gateway } from "../../../gateway";
import { ISecretDTO } from "../interfaces/ISecretDTO";

export type SecretDTOWithId = ISecretDTO & { id: string };

export const updatePasswordVaultAction = async (id: string, dto: ISecretDTO): Promise<SecretDTOWithId> => {
  const token = sessionStorage.getItem("token");

  const res = await gateway.put(`passwords/${id}`, dto, {
    headers: { Authorization: token ? `Bearer ${token}` : "" },
  });

  return res.data;
};
